import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import useWebSocket from "react-use-websocket";
import "./Game.css";
import { WSS, WS_HOST, redicrectAuth } from "../../api";
import { initData } from "@telegram-apps/sdk";

import ReactDice from "react-dice-complete";

const GS = {
  ACCESS_FORBIDDEN: -3,
  LOADING: -1,
  NEW_GAME: 0,
  JOIN_REQUEST: 1,
  JOIN_REQUIRED: 2,
  WAITING_OPPONENT: 3,
  WAITING_JOIN_APPROVE: 4,
  ACTIVE: 5,
  ACTION_LAUNCHED: 6,
  WINNER_SCREEN: 8,
  OPPONENT_RECCONECTING: 9,
};

const JoinGameRequest = ({ gameState, onApprove, onReject }) => {
  return (
    <div className="overlay">
      <div className="modal">
        <p className="modal-title">Request to join the game</p>
        <p className="modal-text">
          User <strong>{gameState.joiningUserId[1]}</strong> wants to join the
          game
        </p>
        <div className="modal-button-container">
          <button className="modal-button-primary" onClick={onApprove}>
            Allow
          </button>
          <button className="modal-button-secondary" onClick={onReject}>
            Deny
          </button>
        </div>
      </div>
    </div>
  );
};

const JoinRejectedView = ({ exit }) => {
  return (
    <div className="overlay">
      <div className="modal">
        <p className="modal-title">Вход запрещен</p>
        <p className="modal-text">Пользователь отклонил запрос</p>
        <div className="modal-button-container">
          <button className="modal-button-primary" onClick={exit}>
            Exit
          </button>
        </div>
      </div>
    </div>
  );
};

const DiceComponent = ({ gameState, gamePhase, rollDone }) => {
  const userId = localStorage.getItem("user_id");

  const reactDicePlayer = useRef();
  const reactDiceOpponent = useRef();

  const [dieSize, setDieSize] = useState(70);

  const updateDieSize = () => {
    const windowHeight = window.innerHeight;
    setDieSize(Math.max(windowHeight * 0.1, 70));
  };

  useEffect(() => {
    updateDieSize();
    window.addEventListener("resize", updateDieSize);
    return () => {
      window.removeEventListener("resize", updateDieSize);
    };
  }, []);

  useEffect(() => {
    if (gamePhase == GS.ACTION_LAUNCHED) {
      reactDicePlayer.current?.rollAll([Number(gameState.playerDice)]);
      reactDiceOpponent.current?.rollAll([Number(gameState.opponentDice)]);
    }
  }, [gamePhase]);

  const getOpacity = () => {
    if (gamePhase == GS.NEW_GAME || gamePhase == GS.LOADING) {
      return 0;
    }
    return 1;
  };

  return (
    <div className="game">
      <div className="dice" style={{ opacity: getOpacity() }}>
        <ReactDice
          defaultRoll={6}
          numDice={1}
          rollTime={3}
          ref={reactDicePlayer}
          disableIndividual
          rollDone={(x, y) => {}}
          dieSize={dieSize}
          dotColor="#191919"
          faceColor="radial-gradient(circle, rgba(242,241,247,1) 0%, rgba(192,194,211,1)"
        />
      </div>
      <div>
        {gamePhase == GS.WINNER_SCREEN && gameState.winner == userId && (
          <div className="resultblock">
            <img className="emoji" src="/trophy_emoji.svg" alt="wonimg" />
            <div className="wontext">You won!</div>
            <img className="emoji" src="/trophy_emoji.svg" alt="wonimg" />
          </div>
        )}
        {gamePhase == GS.WINNER_SCREEN && gameState.winner != userId && (
          <div className="resultblock">
            <img className="emoji" src="/loose_emoji.svg" alt="looseimg" />
            <div className="loosetext">You lose</div>
            <img className="emoji" src="/loose_emoji.svg" alt="looseimg" />
          </div>
        )}
        {gamePhase != GS.WINNER_SCREEN && (
          <div className="resultblock">
            <div className="textbet">Bet</div>
          </div>
        )}
        <div className="betcontainer">
          <img src="/ton.png" alt="toncoin" className="betimage" />
          <div className="textbet">{gameState.bet}</div>
        </div>
      </div>
      <div className="dice" style={{ opacity: getOpacity() }}>
        <ReactDice
          defaultRoll={6}
          numDice={1}
          rollTime={3}
          ref={reactDiceOpponent}
          disableIndividual
          rollDone={rollDone}
          dieSize={dieSize}
          dotColor="#191919"
          faceColor="radial-gradient(circle, rgba(242,241,247,1) 0%, rgba(192,194,211,1)"
        />
      </div>
    </div>
  );
};

const Header = ({ gamePhase, gameState, exit }) => {
  const userName =
    initData.user().firstName || initData.user().username || initData.user().id;

  const avatar = initData.user().photoUrl || "/avatar.svg";

  const phaseToStatus = (gamePhase) => {
    switch (gamePhase) {
      case GS.LOADING:
        return "Creating new game...";
      case GS.NEW_GAME: {
        return gameState.public ? "Searching for opponent..." : "Game Created";
      }
      case GS.JOIN_REQUEST:
        return "Joining request";
      case GS.WAITING_JOIN_APPROVE:
        return "Waiting for approval...";
      case GS.WAITING_OPPONENT:
        return "Waiting for the opponent";
      case GS.ACTIVE:
        return gameState.isAdmin ? "Roll!" : "Waiting for the roll...";
      case GS.OPPONENT_RECCONECTING:
        return "Opponent reconnecting...";
      case GS.ACTION_LAUNCHED:
        return " ";
      case GS.ACCESS_FORBIDDEN:
        return " ";
      case GS.WINNER_SCREEN:
        return " ";
      default:
        return `${gamePhase}`;
    }
  };

  return (
    <div className="header">
      <div className="userinfo">
        <img className="avatar" src={avatar} />
        <div>
          <div className="userid">{userName}</div>
          <div className="gamestatus">{phaseToStatus(gamePhase)}</div>
        </div>
      </div>
      {gamePhase == GS.NEW_GAME && (
        <button className="backbutton" onClick={exit}>
          <img className="imagebuttonback" src="/home.svg" alt="Home" />
        </button>
      )}
    </div>
  );
};

const InviteSection = ({ gameId, setOpen }) => {
  const onCancel = () => {
    setOpen(false);
  };

  const invite = () => {
    const inviteUrl = `https://t.me/secretdice_bot?startapp=${gameId}`;
    navigator.clipboard.writeText(inviteUrl);
    const text =
      "🎲 Let's roll the dice! If the link does not open, try entering the game id.";
    const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(
      inviteUrl
    )}&text=${encodeURIComponent(text)}`;
    setOpen(false);
    window.open(shareUrl, "_blank", "noopener,noreferrer");
  };

  const copyId = () => {
    navigator.clipboard.writeText(gameId);
    setOpen(false);
    alert("The game Id is copied. You can enter it in the Join Game menu.");
  };

  return (
    <div className="overlay">
      <div className="modal">
        <p className="modal-title">Invite a friend</p>
        <div className="modal-button-container-vertical">
          <button
            className="modal-button-primary"
            type="submit"
            onClick={invite}
          >
            Invite
          </button>
          <button
            className="modal-button-primary"
            type="submit"
            onClick={copyId}
          >
            Copy Game Id
          </button>

          <button className="modal-button-secondary" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const InviteButton = ({ gameId }) => {
  const [isMenuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible(!isMenuVisible);
  };

  return (
    <div className="dropup">
      <button className="invitebutton" onClick={toggleMenu}>
        Invite
      </button>
      {isMenuVisible && (
        <InviteSection gameId={gameId} setOpen={setMenuVisible} />
      )}
    </div>
  );
};

const GameView = ({}) => {
  if (redicrectAuth()) {
    window.location.href = "/";
  }

  const [gamePhase, setGamePhase] = useState(GS.LOADING);
  const { id } = useParams();
  const userId = localStorage.getItem("user_id");
  const token = localStorage.getItem("token");

  useEffect(() => {
    console.log("GameView rendered");
  });
  useEffect(() => {
    console.log("gamePhase", gamePhase);
  }, [gamePhase]);

  const { sendJsonMessage } = useWebSocket(
    `${WSS}://${WS_HOST}/ws/${id}/${token}`,
    {
      share: false,
      shouldReconnect: (closeEvent) => true,
      reconnectInterval: 2000,
      reconnectAttempts: 10,
      onOpen: () => {
        console.log("open!");
        sendJsonMessage({ event: "game_state" });
      },
      onClose: () => {
        console.log("close!");
        setGamePhase(GS.LOADING);
      },
      onMessage: (event) => {
        if (gamePhase !== GS.WINNER_SCREEN) {
          const json = JSON.parse(event.data);
          console.log("lastMessage", json);
          if (json.event in handlers) {
            handlers[json.event](json.data);
          } else {
            console.warn("unknown event!", json);
          }
        }
      },
    }
  );

  const [gameState, setGameState] = useState({
    playerDice: "",
    opponentDice: "",
    opponentOnline: false,
    isAdmin: false,
    public: false,
    opponentLastSeen: null,
    winner: null,
    joiningUserId: null,
    bet: null,
    admin: null,
  });

  useEffect(() => {
    if (gameState.admin < 0 && gamePhase == GS.NEW_GAME) {
      setGamePhase(GS.ACTIVE);
    }

    if (gameState.public) {
      if (gameState.isAdmin) {
        const timer = setTimeout(
          () => sendJsonMessage({ event: "fill" }),
          10000 + Math.floor(Math.random() * 5001)
        );
        return () => clearTimeout(timer);
      } else {
        const timer = setTimeout(
          gameAction,
          5000 + Math.floor(Math.random() * 5001)
        );
        return () => clearTimeout(timer);
      }
    }
  }, [gameState]);

  const handleJoiningResponce = (allow) => {
    if (gameState.joiningUserId == null) {
      console.log("joiningUserId is null!");
      return;
    }
    const message = {
      event: "join_request",
      data: { user_id: gameState.joiningUserId[0], allow: allow, game_id: id },
    };
    sendJsonMessage(message);
    if (allow) {
      setGamePhase(GS.WAITING_OPPONENT);
    } else {
      setGamePhase(GS.NEW_GAME);
    }
  };

  const handleGameState = (data) => {
    const updatedGameState = { ...gameState };
    let gs = gamePhase == GS.LOADING ? GS.NEW_GAME : gamePhase;

    if (data.game_state == undefined) {
      console.log("no game state!");
      return;
    }

    if (data.game_state.join_request != undefined) {
      handleJoinRequest(data.game_state.join_request);
      return;
    }

    if (data.game_state.admin != undefined) {
      updatedGameState.isAdmin = userId === data.game_state.admin.toString();
      updatedGameState.admin = data.game_state.admin;
    }
    if (data.game_state.public != undefined) {
      updatedGameState.public = data.game_state.public;
    }

    if (data.game_state.bet != undefined) {
      updatedGameState.bet = data.game_state.bet;
    }

    if (data.game_state.user_status != undefined) {
      const status = data.game_state.user_status;
      for (const u in status) {
        if (u != userId) {
          if (status[u].online) {
            gs = GS.ACTIVE;
          } else {
            gs = GS.OPPONENT_RECCONECTING;
          }
          updatedGameState.opponentLastSeen = status[u].last_seen;
        }
      }
    }

    if (data.game_state.winner != undefined) {
      gs = GS.ACTION_LAUNCHED;

      let playerDice = "";
      let opponentDice = "";
      for (const playerId in data.game_state.dices) {
        const score = data.game_state.dices[playerId];
        if (playerId === userId) {
          playerDice = `${score}`;
        } else {
          opponentDice = `${score}`;
        }
      }
      updatedGameState.playerDice = playerDice;
      updatedGameState.opponentDice = opponentDice;
      updatedGameState.winner = data.game_state.winner;
    }

    console.log("updatedGameState", updatedGameState);
    if (JSON.stringify(updatedGameState) !== JSON.stringify(gameState)) {
      setGameState(updatedGameState);
    }
    setGamePhase(gs);
  };

  const handleJoinRequest = (joining_user_id) => {
    setGameState((prevState) => ({
      ...prevState,
      joiningUserId: joining_user_id,
    }));
    setGamePhase(GS.JOIN_REQUEST);
  };

  const handleAccess = (data) => {
    if (data.allowed) {
      sendJsonMessage({ event: "game_state" });
      setGamePhase(GS.ACTIVE);
    } else {
      setGamePhase(GS.ACCESS_FORBIDDEN);
    }
  };

  const handleInviteRequired = async (data) => {
    setGamePhase(GS.WAITING_JOIN_APPROVE);
  };

  const handleRedirect = (data) => {
    console.log(data.error);
    window.location.href = `/${data.url}`;
  };

  const handlers = {
    game_state: handleGameState,
    invite_required: handleInviteRequired,
    access: handleAccess,
    redirect: handleRedirect,
  };

  const gameAction = () => {
    const message = {
      event: "action",
      game: "dice",
      game_id: id,
    };
    sendJsonMessage(message);
  };

  const exit = () => {
    sendJsonMessage({ event: "exit" });
    setTimeout(() => {
      window.location.href = "/menu";
    }, 200);
  };

  const rollDone = (x, y) => {
    if (gamePhase == GS.ACTION_LAUNCHED) {
      setTimeout(() => setGamePhase(GS.WINNER_SCREEN), 500);
    }
  };

  return (
    <div className="parent">
      <Header gamePhase={gamePhase} gameState={gameState} exit={exit} />
      <DiceComponent
        gameState={gameState}
        gamePhase={gamePhase}
        rollDone={rollDone}
      />
      <div className="bottom">
        {!gameState.public && gamePhase == GS.NEW_GAME && gameState.isAdmin && (
          <InviteButton gameId={id} />
        )}
        {gamePhase == GS.ACTIVE && gameState.isAdmin && (
          <button className="invitebutton" onClick={gameAction}>
            Roll!
          </button>
        )}
        {gamePhase == GS.WINNER_SCREEN && (
          <button className="invitebutton" onClick={exit}>
            {gameState.winner == userId ? "Claim" : "Exit"}
          </button>
        )}
      </div>
      {gamePhase == GS.ACCESS_FORBIDDEN && <JoinRejectedView exit={exit} />}
      {gamePhase == GS.JOIN_REQUEST && (
        <JoinGameRequest
          gameState={gameState}
          onApprove={() => handleJoiningResponce(true)}
          onReject={() => handleJoiningResponce(false)}
        />
      )}
    </div>
  );
};

export default GameView;

// const [error, setError] = useState("");
// const [canDoAction, setcanDoAction] = useState(false);
// const [actionTimer, setActionTimer] = useState(null);
// const [actionProgress, setActionProgress] = useState(120);

// useEffect(() => {
//   const initialMessage = {
//     event: "connection",
//     data: { connected: true },
//   };
//   const sendMessage = () => {
//     sendJsonMessage(initialMessage);
//   };

//   const intervalId = setInterval(sendMessage, 6000);
//   return () => {
//     clearInterval(intervalId);
//   };
// }, []);

// useEffect(() => {
//   setcanDoAction(
//     readyState == ReadyState.OPEN && gameState.playerDice === ""
//   );
// }, [readyState, gameState.playerDice]);

// useEffect(() => {
//   if (
//     !gameState.canLeave &&
//     canDoAction &&
//     gameState.opponentLastSeen == null &&
//     readyState == ReadyState.OPEN
//   ) {
//     const startTime = Math.floor(Date.now() / 1000);
//     const interval = setInterval(() => {
//       const newTimeElapsed = Math.floor(Date.now() / 1000) - startTime;
//       setActionProgress(120 - newTimeElapsed);
//       if (newTimeElapsed >= 120) {
//         clearInterval(interval);
//         setActionProgress(0);
//         gameAction();
//       }
//     }, 1000);

//     setTimer(interval);
//     return () => clearInterval(interval);
//   } else {
//     if (actionTimer) {
//       clearInterval(actionTimer);
//       setActionTimer(null);
//     }
//   }
// }, [gameState.canLeave, gameState.opponentLastSeen, readyState, canDoAction]);
